import { VariantProps, cva } from 'class-variance-authority';

export const checkboxIndicator = cva(
  [
    'shrink-0',
    'overflow-hidden',
    'bg-grayscale0',
    'border',
    'rounded-4',
    'border-grayscale300',
    'hover:bg-primary50',
    'hover:border-primaryMain',
    'active:bg-primary100',
    'active:border-primaryMain',
  ],
  {
    variants: {
      size: {
        small: ['size-12'],
        default: ['size-24'],
      },
    },
    defaultVariants: {
      size: 'default',
    },
  }
);

export type CheckboxIndicatorVariants = VariantProps<typeof checkboxIndicator>;
